export default __webpack_public_path__ + "static/media/gallery_02.4d60cb58.jpg";